import { render, staticRenderFns } from "./edit_lead.vue?vue&type=template&id=c021ce6e&scoped=true"
import script from "./edit_lead.vue?vue&type=script&lang=js"
export * from "./edit_lead.vue?vue&type=script&lang=js"
import style0 from "./edit_lead.vue?vue&type=style&index=0&id=c021ce6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c021ce6e",
  null
  
)

export default component.exports